import { render, staticRenderFns } from "./menu_tree.vue?vue&type=template&id=1850619d&scoped=true"
import script from "./menu_tree.vue?vue&type=script&lang=js"
export * from "./menu_tree.vue?vue&type=script&lang=js"
import style0 from "./menu_tree.vue?vue&type=style&index=0&id=1850619d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1850619d",
  null
  
)

export default component.exports